<div class="my-community-tile" *ngIf="showTile || isLoadingActions">
  <!-- Tile Header -->
  <h3 class="tile-title">My Community</h3>

  <!-- Association Expenses Section - only shown if community-dashboard is enabled -->
  <ng-container
    *ngIf="isCommunityDashboardEnabled && (isLoadingExpenses || hasExpenseData)"
  >
    <div class="expenses-section">
      <h4 class="section-subtitle">{{ chartTitle }}</h4>

      <!-- Loading State -->
      <div *ngIf="isLoadingExpenses" class="chart-loading">
        <div class="skeleton-chart"></div>
      </div>

      <!-- Pie Chart -->
      <dx-pie-chart
        *ngIf="!isLoadingExpenses && hasExpenseData"
        [palette]="chartPalette"
        paletteExtensionMode="blend"
        [dataSource]="expenseData"
        class="expense-chart"
        type="doughnut"
        [innerRadius]="0.5"
        [redrawOnResize]="true"
      >
        <dxo-size [height]="getChartHeight()"></dxo-size>
        <dxo-adaptive-layout [keepLabels]="true"></dxo-adaptive-layout>
        <dxo-legend
          [horizontalAlignment]="getLegendAlignment()"
          [verticalAlignment]="getLegendVerticalAlignment()"
          [customizeText]="customizeLegendText"
          [orientation]="isSmallScreen ? 'horizontal' : 'vertical'"
          [columnItemSpacing]="4"
          [rowItemSpacing]="2"
          [visible]="true"
        >
          <dxo-font [size]="10"></dxo-font>
        </dxo-legend>
        <dxi-series argumentField="title" valueField="balance">
          <dxo-label [visible]="false"></dxo-label>
        </dxi-series>
        <dxo-tooltip
          [enabled]="true"
          [customizeTooltip]="customizeLegendText"
        ></dxo-tooltip>
      </dx-pie-chart>

      <!-- View Community Dashboard Link -->
      <a
        class="tile-link tile-link--dashboard"
        (click)="onViewCommunityDashboardClick()"
        (keydown.enter)="onViewCommunityDashboardClick()"
        tabindex="0"
        role="button"
      >
        View Community Dashboard
      </a>
    </div>
  </ng-container>

  <!-- Management Office Section - only shown if community-info is enabled -->
  <div class="office-section" *ngIf="isCommunityInfoEnabled">
    <h4 class="section-subtitle">Management Office</h4>

    <!-- Loading State -->
    <div *ngIf="isLoadingOffice" class="office-loading">
      <div class="skeleton-text skeleton-name"></div>
      <div class="skeleton-text skeleton-address"></div>
      <div class="skeleton-text skeleton-phone"></div>
    </div>

    <!-- Office Details -->
    <div *ngIf="!isLoadingOffice && managementOffice" class="office-details">
      <!-- Office Name -->
      <div *ngIf="managementOffice.name" class="office-name">
        {{ managementOffice.name }}
      </div>

      <!-- Address Lines -->
      <div
        *ngFor="
          let addressLine of managementOffice.addressLines;
          trackBy: trackByIndex
        "
        class="office-address-line"
      >
        {{ addressLine }}
      </div>

      <!-- Contact Information -->
      <div class="office-contact">
        <div *ngIf="managementOffice.phone" class="contact-item">
          <span class="contact-label">Ph:</span>
          <a [href]="'tel:' + managementOffice.phone" class="contact-phone">
            {{ managementOffice.phone }}
          </a>
        </div>
        <div *ngIf="managementOffice.residentServices" class="contact-item">
          <span class="contact-label">Resident Services:</span>
          <a
            [href]="'tel:' + managementOffice.residentServices"
            class="contact-phone"
          >
            {{ managementOffice.residentServices }}
          </a>
        </div>
        <div *ngIf="managementOffice.email" class="contact-item">
          <span class="contact-label">Email:</span>
          <a
            [href]="'mailto:' + managementOffice.email"
            class="contact-link email-link"
          >
            {{ managementOffice.email }}
          </a>
        </div>
      </div>
    </div>

    <!-- View Community Information Link -->
    <a
      class="tile-link"
      (click)="onViewCommunityInfoClick()"
      (keydown.enter)="onViewCommunityInfoClick()"
      tabindex="0"
      role="button"
    >
      View Community Information
    </a>
  </div>
</div>
